import { PLOT_TYPES, HIGHCHART_COLORS, HIGHCHART_ICONS } from './appConsts'
import { v4 as uuidv4 } from 'uuid'
import { getFormattedAPIDate } from '@/utilities/dates'
import _ from 'lodash'

export const getNextHighchartColor = colors => {
  if (colors.length > HIGHCHART_COLORS.length) {
    return HIGHCHART_COLORS[colors.length % HIGHCHART_COLORS.length]
  }
  const items = HIGHCHART_COLORS.filter(item => !colors.includes(item))
  return items.length > 0 ? items[0] : HIGHCHART_COLORS[0]
}

export const getNextHighchartIcon = icons => {
  return HIGHCHART_ICONS[icons.length % HIGHCHART_ICONS.length]
}

export const getPlotTypeGivenId = id => {
  const [plotType] = PLOT_TYPES.filter(item => item.id === id)
  return plotType || null
}

export const getChartTypeGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.chartType : ''
}

export const getMaxDataTabsGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.maxDataTabs : 1
}

export const getFieldsGivenPlotTypeId = id => {
  const [plotType] = PLOT_TYPES.filter(item => item.id === id)
  return plotType ? plotType.fields : []
}

export const getAxesTabHiddenGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.axes && !plotType.axes.enabled : false
}

export const getOverlaysTabHiddenGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.overlays && !plotType.overlays.enabled : false
}

export const getAxesZoomHiddenGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.axes && !plotType.axes.zoom.enabled : false
}

export const getAxesAutoscaleHiddenGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.axes && !plotType.axes.autoscale.enabled : false
}

export const getAxesYAxisOverridesHiddenGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.axes && !plotType.axes.overrides.enabled : false
}

export const getThresholdsGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.plot && plotType.plot.thresholds : []
}

export const getYAxisMaxValueGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.plot && plotType.plot.max : null
}

export const getYAxisMinValueGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.plot && plotType.plot.min : null
}

export const getYAxisTickIntervalGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)
  return plotType ? plotType.plot && plotType.plot.tickInterval : null
}

export const createNewPagePlotGivenPlotTypeId = id => {
  const plotType = getPlotTypeGivenId(id)

  return {
    id: uuidv4(),
    createdId: uuidv4(),
    title: `${plotType.name} Plot`,
    plotTypeId: id,
    dateCreated: new Date().toISOString(),
    dateSaved: new Date().toISOString(),
    prepopulated: false,
    plotVisible: true,
    options: {
      data: {
        tabs: [
          {
            id: uuidv4(),
            title: 'N/A',
            icon: 'circle',
            iconColor: '#479D9A',
            hidden: false,
            chartType: plotType.seriesType,
            tabIndex: 0,
            tabTitleField: plotType.tabTitleField,
            selection: plotType.fields.map(item => {
              return {
                ...item,
                id: item.id,
                selection: item.showFixedOptions
                  ? item.selection
                  : item.isDate
                  ? getFormattedAPIDate(new Date())
                  : [],
                selectedItems: [],
              }
            }),
          },
        ],
      },
      axes: {
        zoom: plotType.axes.zoom.default || null,
        autoscale: plotType.axes.autoscale.default || false,
        overrides: [],
      },
      overlays: plotType.overlays.options || [],
      separateCharts: false,
    },
  }
}

export const duplicatePagePlot = (pagePlot, newPlotId, tabIds) => {
  const updatedPagePlot = {
    ...pagePlot,
    id: newPlotId,
    title: `${pagePlot.title} (COPY)`,
    dateCreated: new Date(),
    dateSaved: new Date(),
    dateUpdated: new Date().getTime(),
    dataUpdated: new Date().getTime(),
    maintenanceIssueIds: [],
  }
  delete updatedPagePlot.serverId
  updatedPagePlot.options.data.tabs = updatedPagePlot.options.data.tabs.map(
    tab => {
      const [currentTab] = tabIds.filter(item => item.oldTabId === tab.id)
      return {
        ...tab,
        id: currentTab ? currentTab.newTabId : uuidv4(),
      }
    },
  )
  return updatedPagePlot
}

export const duplicateChartData = (chartData, oldPlotId, newPlotId, tabIds) => {
  const filteredItems = chartData.filter(item => item.plotId === oldPlotId)
  const duped = _.cloneDeep(filteredItems)
  const updatedDuped = duped.map(item => {
    const [currentTab] = tabIds.filter(tab => tab.oldTabId === item.tabId)
    return {
      ...item,
      plotId: newPlotId,
      tabId: currentTab ? currentTab.newTabId : uuidv4(),
    }
  })
  return updatedDuped
}
